import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, TaxRate, TaxRateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateTaxRate(): UseMutationResult<
  AxiosResponse<TaxRate>,
  AxiosError<ErrorMessage>,
  TaxRateWrite
> {
  const queryClient = useQueryClient();

  const updateTaxRate = (taxRate: TaxRateWrite): Promise<AxiosResponse<TaxRate>> => {
    return client.put(`tax-rates/${taxRate.taxRateId}/`, taxRate);
  };

  return useMutation(updateTaxRate, {
    onSuccess: () => {
      queryClient.invalidateQueries('taxRates');
    },
  });
}
